export enum ESelectSizesPX {
  px48 = 48,
  px40 = 40,
  px32 = 32,
  px24 = 24,
  px18 = 18,
}

export const paddingForSize = (size: ESelectSizesPX) => {
  switch (size) {
    case ESelectSizesPX.px48:
    case ESelectSizesPX.px40:
      return 10;
    case ESelectSizesPX.px32:
    case ESelectSizesPX.px24:
    case ESelectSizesPX.px18:
      return 5;
    default:
      return 5;
  }
};
